(function() {
  var stringUtil;

  stringUtil = exports;

  stringUtil.toFunction = function(str) {
    return stringUtil.toElementIn(str, window);
  };

  stringUtil.toElementIn = function(str, obj) {
    var arr, fn, i, j, len, v;
    arr = str.split('.');
    fn = obj;
    for (i = j = 0, len = arr.length; j < len; i = ++j) {
      v = arr[i];
      fn = fn[v];
    }
    if (fn == null) {
      throw new Error("couldn't find " + str);
    }
    return fn;
  };

  stringUtil.setElementIn = function(str, value, obj) {
    var arr, fn, i, j, len, v;
    arr = str.split('.');
    fn = obj;
    for (i = j = 0, len = arr.length; j < len; i = ++j) {
      v = arr[i];
      if (i === arr.length - 1) {
        fn[v] = value;
      } else {
        if ((fn[v] != null) && !(typeof fn[v] === 'object')) {
          throw new Error("Can't descend into " + fn[v] + ", it's not an object.");
        }
        if (fn[v] == null) {
          fn[v] = {};
        }
      }
      fn = fn[v];
    }
    return fn;
  };

  stringUtil.studlyCase = function(str) {
    str = stringUtil.camelCase(str);
    return stringUtil.capitalize(str);
  };

  stringUtil.camelCase = function(str) {
    var arr, head, tail;
    str = stringUtil.allLower(str);
    arr = str.split(/[, -_]/);
    tail = List.map((function(x) {
      return stringUtil.capitalize(x);
    }), List.tail(arr));
    head = [List.head(arr)];
    arr = head.concat(tail);
    return arr.join('');
  };

  stringUtil.capitalize = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  stringUtil.allLower = function(str) {
    return str.replace(/.*/g, (function(x) {
      return x.toLowerCase();
    }));
  };

  stringUtil.allUpper = function(str) {
    return str.replace(/.*/g, (function(x) {
      return x.toUpperCase();
    }));
  };

  stringUtil.studlyToWords = function(str) {
    return str.replace(/([A-Z])/g, ' $1');
  };

  stringUtil.contains = function(str, val) {
    if (str.indexOf(val) !== -1) {
      return true;
    }
    return false;
  };

  stringUtil.startsWith = function(str, val) {
    if (str.match("^" + val) != null) {
      return true;
    }
    return false;
  };

  stringUtil.endsWith = function(str, val) {
    if (str.match(val + "$") != null) {
      return true;
    }
    return false;
  };

}).call(this);
